// Frittstående etterretnings-panel (poppet ut til egen skjerm). Egen WS-feed
// (cookie-auth); mottar delte produkter via hubbens intel-fanout og kan
// produsere/dele nye. «⌖» fokuserer hovedkartet via SyncBus.
import { parseIntelOne } from '@skade/contracts';
import type { Feed } from '../data/feed.js';
import type { SyncBus } from '../sync.js';
import type { User } from '@skade/rbac';
import { IntelWorkspace } from '../ui/intel.js';

export function mountIntelPanel(root: HTMLElement, feed: Feed, sync: SyncBus, user: User): void {
  document.body.classList.add('panel-standalone');
  root.innerHTML = '';
  const wrap = document.createElement('div');
  wrap.className = 'standalone-panel';
  const head = document.createElement('div');
  head.className = 'standalone-head';
  head.append(txt('brand', 'SKADE'), txt('standalone-title', 'Etterretning'));
  const host = document.createElement('div');
  host.className = 'intel-host embedded';

  const ws = new IntelWorkspace({
    user,
    onShare: (p) => feed.send?.({ type: 'intel', intel: p }),
    onFocus: (lat, lon) => sync.post({ type: 'focus', lon, lat, label: 'INTEL' }),
  });
  host.append(ws.el);
  wrap.append(head, host);
  root.append(wrap);

  feed.onCollab?.((m) => {
    if (m.kind === 'intel' && m.intel) { const p = parseIntelOne(m.intel); if (p) ws.ingest(p); }
  });
  feed.start();
}

function txt(cls: string, text: string): HTMLElement {
  const e = document.createElement('span');
  e.className = cls;
  e.textContent = text;
  return e;
}
